const GTMPath: React.FC<{ path: string }> = ({ path }) => {
  return (
    <div className="sr-only" aria-hidden id="gtm-path">
      {path}
    </div>
  );
};

export default GTMPath;
